import { EmptyState, Mtds, SinglePlan } from 'prove-common'
import TasksTable from '../../tables/TasksTable'

const NO_GROUPING: string[] = []

type TasksTabProps = {
  plan: SinglePlan
}

export default function TasksTab({ plan }: Readonly<TasksTabProps>) {
  return (
    <Mtds.Grid>
      <Mtds.Flex data-align='start' data-justify='space-between'>
        <Mtds.Heading as='h2' data-size='sm'>
          Oppgaver <Mtds.Badge data-badge={plan.tasks?.length ?? 0} />
        </Mtds.Heading>
      </Mtds.Flex>
      {plan.tasks?.length ? (
        <TasksTable plan={plan} grouping={NO_GROUPING} />
      ) : (
        <EmptyState
          title='Ingen oppgaver'
          description='Denne planen har ingen oppgaver ennå.'
        />
      )}
    </Mtds.Grid>
  )
}
